var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useEffect, useState } from 'react';
import styles from './Calendar.module.css';
import addDays from 'date-fns/addDays';
import dateIsAfter from 'date-fns/isAfter';
import dateFormat from 'date-fns/format';
import parseISO from 'date-fns/parseISO';
import DayPicker from 'react-day-picker';
import Button from '../Button';
import ChevronLeft from '../../icons/ChevronLeft';
import ChevronRight from '../../icons/ChevronRight';
import { convertToSiteTz } from '../../utils/date';
const CalendarNav = ({ onPreviousClick, onNextClick, className, }) => {
    return (_jsxs("div", Object.assign({ className: className }, { children: [_jsx("div", Object.assign({ className: styles.navButtonPrev }, { children: _jsx(Button, Object.assign({ variant: "text", onClick: () => onPreviousClick() }, { children: _jsx("span", Object.assign({ className: styles.navButtonColor }, { children: _jsx(ChevronLeft, { variant: "tiny", size: 20 }, void 0) }), void 0) }), void 0) }), void 0), _jsx("div", Object.assign({ className: styles.navButtonNext }, { children: _jsx(Button, Object.assign({ variant: "text", onClick: () => onNextClick() }, { children: _jsx("span", Object.assign({ className: styles.navButtonColor }, { children: _jsx(ChevronRight, { variant: "tiny", size: 20 }, void 0) }), void 0) }), void 0) }), void 0)] }), void 0));
};
export const Calendar = React.memo((_a) => {
    var { from, to, onChange, limitRangeSelection, disableToday, disableFuture, disableBefore, disableAfter, isSingleDay, selectedSingleDay, displayMonthOnly, ianaTimeZoneCode } = _a, props = __rest(_a, ["from", "to", "onChange", "limitRangeSelection", "disableToday", "disableFuture", "disableBefore", "disableAfter", "isSingleDay", "selectedSingleDay", "displayMonthOnly", "ianaTimeZoneCode"]);
    const [selectedDateRange, setSelectedDateRange] = useState({
        from: from ? parseISO(from) : undefined,
        to: to ? parseISO(to) : undefined,
    });
    useEffect(() => {
        setSelectedDateRange({
            from: from ? parseISO(from) : undefined,
            to: to ? parseISO(to) : undefined,
        });
    }, [from, to]);
    const handleDateRangeClick = (day, modifiers) => {
        const dateFrom = from ? new Date(`${from}T00:00:00`) : null;
        if (modifiers === null || modifiers === void 0 ? void 0 : modifiers.disabled) {
            return;
        }
        // start a new date range or check if new to is after from date
        if (onChange &&
            ((!from && !to) ||
                (from && to) ||
                (dateFrom && dateIsAfter(dateFrom, day)))) {
            onChange({
                from: dateFormat(day, 'yyyy-MM-dd'),
                to: undefined,
            });
            setSelectedDateRange({
                from: day,
                to: undefined,
            });
            return;
        }
        if (onChange && from && to === undefined) {
            onChange({
                from: dateFormat(parseISO(from), 'yyyy-MM-dd'),
                to: dateFormat(day.valueOf(), 'yyyy-MM-dd'),
            });
            setSelectedDateRange({
                from: parseISO(from),
                to: day,
            });
        }
    };
    const [selectedDay, setSelectedDay] = useState(selectedSingleDay ? new Date(`${selectedSingleDay}T00:00:00`) : undefined);
    const handleSingleDayClick = (day, modifiers) => {
        if (modifiers === null || modifiers === void 0 ? void 0 : modifiers.disabled) {
            return;
        }
        if (onChange) {
            onChange(dateFormat(day, 'yyyy-MM-dd'));
            setSelectedDay(day);
        }
    };
    const disabledDays = (() => {
        const disabledDaysArray = [];
        const today = convertToSiteTz(new Date(), ianaTimeZoneCode);
        if (from && !to && limitRangeSelection) {
            disabledDaysArray.push({
                after: addDays(parseISO(from), limitRangeSelection - 1),
            });
        }
        if (disableToday) {
            disabledDaysArray.push(today);
        }
        if (disableFuture) {
            disabledDaysArray.push({
                after: today,
            });
        }
        if (disableBefore) {
            disabledDaysArray.push({
                before: new Date(`${disableBefore}T00:00:00`),
            });
        }
        if (disableAfter) {
            disabledDaysArray.push({
                after: new Date(`${disableAfter}T00:00:00`),
            });
        }
        return disabledDaysArray.length > 0 ? disabledDaysArray : undefined;
    })();
    const selectedStyle = {
        [styles.selectedStart]: isSingleDay
            ? selectedDay
            : selectedDateRange.from,
        [styles.selectedEnd]: isSingleDay ? selectedDay : selectedDateRange.to,
    };
    return (_jsx(DayPicker, Object.assign({ selectedDays: !displayMonthOnly
            ? isSingleDay
                ? selectedDay
                : selectedDateRange
            : undefined, classNames: styles, numberOfMonths: isSingleDay ? 1 : 2, modifiers: Object.assign(Object.assign({}, (!displayMonthOnly ? selectedStyle : {})), { 
            //this adds disabled modifier to be checked in handleDayClick
            disabled: disabledDays }), month: isSingleDay ? selectedDay : selectedDateRange.from, onDayClick: isSingleDay ? handleSingleDayClick : handleDateRangeClick, 
        // Not sure why TS yells at this
        // @ts-ignore
        navbarElement: _jsx(CalendarNav, {}, void 0), 
        //this adds className .disabled in css
        disabledDays: disabledDays }, props), void 0));
});
export default Calendar;
